import { Component, OnDestroy, OnInit } from '@angular/core';

import { AppService } from '../services/app.service';
import { HeaderService } from '../services/header.service';

@Component({
  templateUrl: "./system-error.component.html"
})
export class SystemErrorComponent implements OnInit, OnDestroy {
  public manageLink: any;
  public errMsg: string = '';
  constructor(public headerService: HeaderService, public appService: AppService) {

  }

  ngOnInit() {
    this.headerService.getSystemProperties().then(properties => this.manageLink = properties["GO_TO_IAM"]);
    this.appService.getUserProfile().then(user => {
      if (user.isConsumerAccount() || !user.isRoleGlobal()) {
        this.errMsg = `The account you are using to sign in to this application is a personal account. Please use your business account to sign in. If you do not have 
                a business account, please log out and then use the "Create Account" button on sign up page.`;
      } else {
        this.errMsg = `Our records indicate that you have not requested access to the Test Accessibility and Accommodations System.`;

      }
    });
  }
  logout() {
    this.headerService.logout().then((response: any) => {
      if (response && response.logoutLink) {
        window.location.href = response.logoutLink;
      }
    });
  }

  ngOnDestroy() { }
}



// WEBPACK FOOTER //
// ./client/views/system-error/system-error.component.ts